import React from "react"
import VideoEmbed from "../VideoEmbed/VideoEmbed"
import CodeEmbed from "../CodeEmbed/CodeEmbed"
import { StatamicHtml, prefixStatamicAssetUrl } from "../../../../utils/statamicAssets"
import { headingAltTextInHtml } from "../utils/flexipageHelpers"

const VIDEO_TYPES = new Set([
  "Statamic_Set_PageRows_Copy_Video",
  "Statamic_Set_PageRows_AltRowItems_Copy_Video",
])

const CTA_TYPES = new Set([
  "Statamic_Set_PageRows_Copy_CallToAction",
])

const CODE_EMBED_TYPES = new Set([
  "Statamic_Set_PageRows_Copy_CodeEmbed",
])

const BardCopy = ({ nodes, className, as: Tag = "div", ...rest }) => {
  if (!nodes || nodes.length === 0) return null

  return (
    <Tag className={className} {...rest}>
      {nodes.map((node, i) => {
        if (!node || !node.__typename) return null

        if (node.__typename === "Statamic_BardText") {
          return (
            <StatamicHtml
              key={i}
              html={headingAltTextInHtml(node.text)}
              as="div"
              className="bard-text"
            />
          )
        }

        if (VIDEO_TYPES.has(node.__typename) && node.video_url) {
          return (
            <div key={i} className="bard-video">
              <VideoEmbed url={node.video_url} />
            </div>
          )
        }

        if (CODE_EMBED_TYPES.has(node.__typename)) {
          return (
            <CodeEmbed
              key={i}
              html={node.embed_html}
              scriptUrl={node.embed_script_url}
              script={node.embed_script}
            />
          )
        }

        if (CTA_TYPES.has(node.__typename)) {
          const iconUrl = node.icon
            ? prefixStatamicAssetUrl(node.icon.permalink || node.icon.url)
            : null
          return (
            <a
              key={i}
              href={node.link || "#"}
              className="bard-cta"
            >
              {iconUrl && (
                <img
                  src={iconUrl}
                  alt={node.icon?.alt || ""}
                  className="bard-cta-icon"
                />
              )}
              <span className="bard-cta-label">{node.label}</span>
            </a>
          )
        }

        return null
      })}
    </Tag>
  )
}

export default BardCopy
